import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGlobe,
  faUser,
} from '@fortawesome/pro-light-svg-icons'

import { Box, StatusBadge, Text } from '@domain-group/suit-theme'

import { statusColors } from '@functions/status'

import useQuoteBuilder from '../../hooks/useQuoteBuilder'

interface RecipientDetailsProps {
  quoteBuilderPayload: ReturnType<typeof useQuoteBuilder>,
}

const RecipientDetails = (props: RecipientDetailsProps) => {
  const {
    quoteBuilderPayload: {
      campaignQuotePayload: {
        campaignQuote: {
          recipient_email,
          recipient_name,
          recipient_phone,
          total,
        },
        recipientAddressParts,
        status,
      },
    },
  } = props

  return (
    <Box borderBottom="1px solid" borderColor="lineColor" padding="large">
      <Box flexDirection={['column', 'row']}>
        {/* Vendor Details */}
        <Box alignItems="center" width="auto">
          <Text color="bodyFontLightColor" width={16}>
            <FontAwesomeIcon icon={faUser} />
          </Text>

          <Box flexDirection="column" marginLeft="large">
            <Text className="mp-mask" fontSize="small">{recipient_name}</Text>
            <Text className="mp-mask" color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
              {recipient_phone}
            </Text>
            <Text className="mp-mask" color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
              {recipient_email}
            </Text>
          </Box>
        </Box>
        {/* End Vendor Details */}

        {/* Address Details */}
        <Box alignItems="center" marginLeft={[0, 'large']} marginTop={['large', 0]} width="auto">
          <Text color="bodyFontLightColor" width={16}>
            <FontAwesomeIcon icon={faGlobe} />
          </Text>

          <Box className="mp-mask" flexDirection="column" marginLeft="large">
            {recipientAddressParts.map((addressPart, index) => (
              <Text
                color={index !== 0 ? 'bodyFontLightColor' : 'bodyFontColor'}
                key={index}
                fontSize={index === 0 ? 'small' : 'xsmall'}
                marginTop={index !== 0 ? 'small' : null}
              >
                {addressPart}
              </Text>
            ))}
          </Box>
        </Box>
        {/* End Address Details */}
      </Box>

      {/* Status & Total */}
      <Box alignItems="flex-end" flexDirection="column" justifyContent="center" marginLeft="auto" width="auto">
        <StatusBadge
          // @ts-expect-error TS7053
          color={statusColors[status.key || 'pending']}
          ghost
          // @ts-expect-error TS2339
          text={status.title || 'Pending'}
        />

        <Text fontSize="medium" marginTop="medium">
          {formatMoney(total)}
        </Text>
      </Box>
      {/* End Status & Total */}
    </Box>
  )
}

export default RecipientDetails
